import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'addressFilter',
  pure: false,
  standalone: false
})
export class AddressFilterPipe implements PipeTransform {

  transform(values: { id: number }[], currentlySelectedId: string, ...args: unknown[]): unknown {
    return values.filter( v => v.id.toString() !== currentlySelectedId);
  }

}
